import { LoadMore } from '../elements/load-more'
import {Swiper} from 'swiper'
import {breakpointDown} from "../helpers/breakpoints";
import { ScrollTrigger } from 'gsap/ScrollTrigger'


function initProducts()
{
  const loadMoreBlock = $('.js-load-more-block')

  if (loadMoreBlock.length){
    const eventsLoadMore = new LoadMore(loadMoreBlock)
  }


  //-- Filter buttons slider
  $('.js-resp-cats-swiper').each((i, el)=> {

    if (breakpointDown('xl')) {


      // animate  when in screen
      let swiperLastEl = $(el).find('.swiper-slide').last()
      if (swiperLastEl.offset().left + swiperLastEl.width() > window.innerWidth - 20) {

        let swiper = new Swiper(el, {
          slidesPerView: 'auto',
        });

        ScrollTrigger.create({
          trigger: el,
          start: "top bottom", // el top, screen bottom
          once: true,
          onEnter: () => {
            $(el).find('.swiper-wrapper').delay(400).animate({ left: '-80px' }, 600,
              function () {
                $(this).animate({ left: 0 }, 600)
              })
          }
        });

      }

    }

  }) // -- End Filter Buttons Slider ----


}

initProducts()
